module.exports = __webpack_public_path__ + "img/7.eba2d72f.jpg";